<script setup>
import { useModalStore } from '@/stores/modals';

const modals = useModalStore();
</script>

<template>
  <Teleport to="body">
    <component
      :is="entry.component"
      v-for="entry in modals.stack"
      :key="entry.id"
      v-bind="entry.props"
      @close="(result) => modals.close(entry.id, result)"
    />
  </Teleport>
</template>
